'use client';

import { clientErrorLoggerApiService } from '@/services/(frontend)/client-error-logger-api.service';
import Image from 'next/image';
import { useEffect } from 'react';

const Error = ({
  error,
}: {
  error: Error;
}): React.JSX.Element => {
  useEffect(() => {
    void clientErrorLoggerApiService.logError(error);
  }, [error]);

  return (
    <div className="container-lg mx-auto flex flex-col gap-4 my-8 text-center items-center">
      <h1 data-test="error-header">Something went wrong</h1>
      <p data-test="error-message">We're not sure what happened, but we're working on it.</p>
      <p data-test="error-suggestion">Try refreshing the page or returning to the home page.</p>
      <Image alt="Error illustration"
        aria-label="Error illustration"
        className="h-auto max-w-[386.41px]"
        height={170}
        src="/img/error.svg"
        width={386}
      />
    </div>
  );
};

export default Error;
